import { ChatMessageChunk, OnChunkCallback } from 'nekst-api';

interface StreamRelay {
  listener: OnChunkCallback | null;
  buffer: ChatMessageChunk[];
}

const relay: StreamRelay = {
  listener: null,
  buffer: [],
};

export function createRelayDispatcher(): OnChunkCallback {
  relay.buffer = [];
  return (chunk: ChatMessageChunk) => {
    if (relay.listener) {
      relay.listener(chunk);
    } else {
      relay.buffer.push(chunk);
    }
  };
}

export function attachRelayListener(listener: OnChunkCallback) {
  relay.listener = listener;
  const buffered = relay.buffer;
  relay.buffer = [];
  buffered.forEach((chunk) => listener(chunk));
}

export function detachRelayListener() {
  relay.listener = null;
}

export function hasActiveRelay(): boolean {
  return relay.listener !== null || relay.buffer.length > 0;
}

export function clearRelay() {
  relay.listener = null;
  relay.buffer = [];
}
